// Lectura del código por QR: hoy sin cámara; `readCode` ya normaliza lo que entregue el lector.
import { useCallback } from 'react';
import { normalizeDiscountCode } from '../lib/discountCodeText';

export interface DiscountCodeScanner {
    /** `false` mientras no haya lector de QR en el wizard. */
    available: boolean;
    readCode: (decoded: string) => string;
}

export function useDiscountCodeScanner(): DiscountCodeScanner {
    const readCode = useCallback((decoded: string) => normalizeDiscountCode(decoded), []);
    return { available: false, readCode };
}
